var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrashcan = function SvgTrashcan(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.9 999.3h620.4c19.3 0 34.3-15 34.3-34.3V272.1h86.2c19.3 0 34.3-15 34.3-34.3 0-9.5-4-17.8-9.5-23.3-6.8-6.8-15-9.5-23.3-9.5h-241V33.6c0-19.3-15-34.3-32.8-34.3H343.2c-19.3 0-34.3 15-34.3 34.3v171.2H69.4c-19.3 0-34.3 15-34.3 34.3s15 34.3 34.3 34.3h86.2v693.1c1.4 17.8 16.5 32.8 34.3 32.8M376.3 66.6h247.8V205H376.3zM224.2 272.1h553.5v658.8H224.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M604.9 355.6c-19.3 0-34.3 15-34.3 34.3v426c0 19.3 15 34.3 34.3 34.3s34.3-15 34.3-34.3V388.4c0-17.8-15.1-32.8-34.3-32.8M395.3 355.6c-19.3 0-34.3 15-34.3 34.3v426c0 19.3 15 34.3 34.3 34.3s34.3-15 34.3-34.3V388.4c.1-17.8-15-32.8-34.3-32.8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrashcan);
export default ForwardRef;